/**
 * Placeholder identifiers for the OneTap flow (`/tap/:cardType`).
 *
 * OneTap does not create a real session — the card tap is validated against
 * a hardcoded intentOwner/workflow until the BFF defines a real OneTap
 * session/eligibility contract. Replace these once that contract exists.
 *
 * sessionId is NOT hardcoded — each validate call generates a fresh
 * crypto.randomUUID() (see validateOneTap in src/api/bff.ts), the same
 * primitive devportal-bff uses for session/tokenized ids
 * (AirKey-dev-portal-backend-resources/devportal-bff/src/services/authentication/index.ts).
 */
export const ONETAP_INTENT_OWNER = 'OneTap';
export const ONETAP_WORKFLOW = 'Validation';

/**
 * `:cardType` identifies the LOB of the tapped card. For this POC only
 * bank cards support OneTap ("URI mode"), so the only value seen in
 * practice today is `'bank'`. It is not yet used to select a config or
 * change behavior (see validateOneTap in src/api/bff.ts) — it's captured
 * for tracing/logging so future LOBs (e.g. card, premium) can be added
 * without changing the route shape.
 */
export const ONETAP_CARD_TYPE_BANK = 'bank';
